import { types } from 'mobx-state-tree'
import { validators } from '../..'
import { editableModel } from '../helpers/editable'
import { validateLetterAndWhiteSpace } from '../helpers/validations'

const { validateUSPhoneNumber, validateEmail } = validators

interface OwnerTypes {
  firstName: string
  lastName: string
  email: string
  phone: string
  invited: boolean
  validEmail: boolean
  validPhone: boolean
}
const views = (self: OwnerTypes) => ({
  get validPhone() {
    return validateUSPhoneNumber(self.phone)
  },
  get validEmail() {
    return validateEmail(self.email)
  },
  get allMandatoryFilled() {
    return (
      validateLetterAndWhiteSpace(self.firstName) &&
      validateLetterAndWhiteSpace(self.lastName) &&
      self.validEmail &&
      self.validPhone
    )
  },
})

export const Owner = types
  .compose(
    types.model({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      invited: types.optional(types.boolean, false),
    }),
    editableModel(),
  )
  .views((self) => views(self as unknown as OwnerTypes))
